import React, { useState } from 'react';
import { useQuery } from 'react-query';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as documentService from '../../services/documents';
import { FiPlus, FiSearch, FiFilter } from 'react-icons/fi';
import { MdDescription } from 'react-icons/md';
import './Documents.scss';

const Documents = () => {
  const [filters, setFilters] = useState({
    search: '',
    status: '',
    category: '',
    page: 1,
    limit: 20,
  });

  const { data, isLoading, refetch } = useQuery(
    ['documents', filters],
    () => documentService.getDocuments(filters),
    {
      keepPreviousData: true,
    }
  );

  return (
    <div className="documents-page">
      <div className="page-header">
        <div>
          <h1>Documents</h1>
          <p>Manage and organize all your documents</p>
        </div>
        <Link to="/documents/create" className="btn btn-primary">
          <FiPlus /> Create Document
        </Link>
      </div>

      <div className="documents-filters">
        <div className="search-box">
          <FiSearch className="search-icon" />
          <input
            type="text"
            placeholder="Search documents..."
            value={filters.search}
            onChange={(e) => setFilters({ ...filters, search: e.target.value, page: 1 })}
          />
        </div>
        <select
          className="form-control"
          value={filters.status}
          onChange={(e) => setFilters({ ...filters, status: e.target.value, page: 1 })}
        >
          <option value="">All Status</option>
          <option value="draft">Draft</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="archived">Archived</option>
        </select>
      </div>

      <div className="documents-grid">
        {isLoading ? (
          <div className="loading-placeholder">
            {[...Array(6)].map((_, i) => (
              <div key={i} className="document-card skeleton">
                <div className="skeleton skeleton-text"></div>
                <div className="skeleton skeleton-text"></div>
              </div>
            ))}
          </div>
        ) : data?.documents?.length > 0 ? (
          data.documents.map((doc) => (
            <motion.div
              key={doc._id}
              className="document-card"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
            >
              <Link to={`/documents/${doc._id}`}>
                <div className="document-header">
                  <div className="document-icon">
                    <MdDescription />
                  </div>
                  <div className={`status-badge status-${doc.status}`}>
                    {doc.status}
                  </div>
                </div>
                <div className="document-body">
                  <h3>{doc.name}</h3>
                  <p className="document-number">{doc.documentNumber}</p>
                  <p className="document-meta">
                    {new Date(doc.createdAt).toLocaleDateString()}
                  </p>
                </div>
              </Link>
            </motion.div>
          ))
        ) : (
          <div className="empty-state">
            <MdDescription className="empty-icon" />
            <p>No documents found</p>
            <Link to="/documents/create" className="btn btn-primary">
              Create First Document
            </Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Documents;
